import { render } from "./dialog_external_card.vue?vue&type=template&id=774558c9"
import script from "./dialog_external_card.vue?vue&type=script&lang=js"
export * from "./dialog_external_card.vue?vue&type=script&lang=js"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/cdas-intranet-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__